/*
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author: Zhanglei
 * @Date: 2020-07-27 17:49:48
 * @LastEditTime: 2020-08-24 09:38:53
 * @LastEditors: Zhanglei
 * @Description:
 * @FilePath: /desktop/src/service/languageService.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */
import request from "@/utils/request";
// 发送当前语言环境获取i18n文件
export function getLanguagesFileApi(language) {
  return request({
    url: "/api/v1/system/i18ns/" + language,
    method: "GET",
    data: { language: language }
  });
}
// 获取支持语言列表
export function getLanguagesListApi() {
  return request({
    url: "/api/v1/system/i18ns",
    method: "GET"
  });
}
// 获取页面数据
export function getI18nDataApi(idInfo) {
  return request({
    url: "/api/v1/i18ns" + idInfo,
    method: "GET",
    data: idInfo
  });
}
// 更改编辑数据
export function getChangeDataApi(data) {
  return request({
    url: "/api/v1/i18ns/" + data.id,
    method: "PATCH",
    data: data.data
  });
}
// 删除数据
export function deleteDataApi(id) {
  return request({
    url: "/api/v1/i18ns/" + id,
    method: "DELETE"
  });
}
// 创建数据
export function postDataApi(data) {
  return request({
    url: "/api/v1/i18ns/",
    method: "POST",
    data: data
  });
}



// WEBPACK FOOTER //
// ./src/service/languageService.js